import axios from "axios";
import { Base_URL } from "../url";

export const fetchSupplyTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/SupplyTypeMaster/GetAllSupplyTypes`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching supply types!";
  }
};

export const downloadSupplyTypesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/SupplyTypeMaster/DownloadSupplyTypesExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading supply types data!";
  }
};